<script setup>
import { useUserStore } from '@/plugins/store/user.ts'
import { useAppStore } from '@/plugins/store/app.ts'
import { useRouter } from 'vue-router'


const app = useAppStore()
const user = useUserStore()
const router = useRouter()
</script>

<template>
  <v-card-item>
    <div>
      <div class="text-overline mb-1">
        OVERLINE
      </div>
      <div class="text-h6 mb-1">
        Headline
      </div>
      <div class="text-caption">Greyhound divisely hello coldly fonwderfully</div>
    </div>
  </v-card-item>

  <v-card-actions class="account-actions">

    <v-btn icon v-if="user?.userData?.role == 'admin'" @click="router.push('/admin')">
      <v-icon icon="mdi-application-cog" />
    </v-btn>

    <v-btn icon @click="app.changeTheme(app.theme == 'defaultTheme' ? 'lightTheme' : 'defaultTheme')" color="primary">
      <v-icon icon="mdi-theme-light-dark" />
    </v-btn>

    <v-btn icon>
      <v-icon icon="mdi-cog" />
    </v-btn>

    <v-btn icon @click="user.logOut()">
      <v-icon icon="mdi-logout-variant" />
    </v-btn>
  </v-card-actions>
</template>

<style>
.account-actions {
  position:absolute;
  bottom: 0;
  right: 0;
}
</style>